<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="d-flex justify-content-center">
        <div>1401 © همیار مکانیک کوشا</div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters(["getPage"]),
  },
  created() {
    this.setPage("dashboard");
  },
  methods: {
    ...mapActions(["setPage"]),
  },
};
</script>